import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { RELEASE_NOTES } from '../config';
import { markReleaseSeen, shouldShowReleaseNotes } from '../utils/appRelease';

function WhatsNewModal() {
    const [open, setOpen] = useState(() => shouldShowReleaseNotes(RELEASE_NOTES));

    const title = (RELEASE_NOTES?.title || 'What’s new').trim() || 'What’s new';
    const body = (RELEASE_NOTES?.body || '').trim();

    const dismiss = () => {
        markReleaseSeen(RELEASE_NOTES?.id);
        setOpen(false);
    };

    return (
        <Modal show={open} onHide={dismiss} centered className="whats-new-modal">
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {body ? (
                    <p className="whats-new-modal__body">{body}</p>
                ) : (
                    <p className="whats-new-modal__body">A new version of Flow is available.</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={dismiss}>
                    Got it
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default WhatsNewModal;
